module.exports = __webpack_public_path__ + "img/extention_collect.a93b36c9.png";